<template>
  <div>
    <Header />
    <div v-if="hasLoaded" class="body-content">
      <div class="shadow mb-2">
        <div class="details-panel">
          <div class="left">
            <p>Welcome to the SMF client portal, {{fullName}}</p>
          </div>
        </div>
      </div>

      <agreement-panel :mode="'all'" style="margin-top: 10px;" :user="user" />

      <div class="shadow">
        <div class="details-panel flex-col-reverse md:flex-row">
          <div class="left">
            <customer-details-panel :user="user" :editable="false" />
          </div>
          <div class="right">
            <svg
              enable-background="new 0 0 48 48"
              height="48px"
              id="Layer_1"
              version="1.1"
              viewBox="0 0 48 48"
              width="48px"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              style="fill:#C38D9E;flex-shrink:0"
            >
              <g id="Layer_3">
                <path
                  d="M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M24,44   C12.954,44,4,35.046,4,24S12.954,4,24,4s20,8.954,20,20S35.046,44,24,44z"
                />
                <g>
                  <circle cx="24" cy="33" r="2" />
                  <rect height="15.031" width="3.997" x="22.001" y="12.969" />
                </g>
              </g>
            </svg>
            <p
              style="text-align:center;padding:10px;"
            >It is important that all of these details are correct, if any of the information on this page is incorrect please contact SMF using the contact link in the navigation bar.</p>
          </div>
        </div>
      </div>

      <div class="other-details">
        <div class="shadow half-width min-300 margin-top-10">
          <div class="contact-panel">
            <p style="text-align: left;margin-left: 10px;"><b>Other Contact Methods</b></p>
            <br />
            <DataGrid class="margin-5" :contactArray="user.contact" />
          </div>
        </div>
        <div class="shadow half-width flex justify-center items-center min-300 margin-top-10 margin-left-10">
          <VehiclePanel :user="user" :editable="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DataGrid = () => import("@/components/ContactDataGrid");
const CustomerDetailsPanel = () => import("@/components/CustomerDetailsPanel");
const Header = () => import("@/components/Header");
const AgreementPanel = () => import("@/components/AgreementDetailsPanel");
const VehiclePanel = () => import("@/components/VehicleDetailsPanel");

export default {
  name: "CustomerDetails",
  components: {
    DataGrid,
    CustomerDetailsPanel,
    Header,
    AgreementPanel,
    VehiclePanel,
  },
  data() {
    return {
      hasLoaded: false,
      user: Object
    };
  },
  computed: {
    fullName() {
      return this.user.forename + " " + this.user.surname;
    }
  },
  async created() {
    //data in the store isnt reactive so we need to add it as a component property
    this.user = this.$store.getters.user;
    //Used as a toggle to hide the page contents until the data has loaded, only needed if the user object is refreshed before loading this page
    this.hasLoaded = true;
  },
};
</script>

<style scoped>
.body-content {
	margin: 0 auto;
	width: 98%;
}

.body-content .shadow {
	-webkit-box-shadow: 3px 2px 14px -1px #cccccc;
	-moz-box-shadow: 3px 2px 14px -1px #cccccc;
	box-shadow: 3px 2px 14px -1px #cccccc;
	background-color: white;
	border-bottom: 2px solid #41b3a3;
}

.body-content .shadow .contact-panel {
	padding: 20px;
}

.body-content .shadow .contact-panel h4 {
	margin: 0;
	padding: 0;
	text-align: left;
}

.body-content .shadow .contact-panel .margin-5 {
	margin: 5px;
}

.body-content .shadow .details-panel {
	text-align: left;
	padding: 20px;
	display: flex;
	flex-wrap: wrap;
}

.body-content .shadow .details-panel .left {
	flex: 1;
}

.body-content .shadow .details-panel .right {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.body-content .shadow .details-panel p {
	margin: 0;
}

.other-details {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}

.other-details .half-width {
	flex: 1;
}

.other-details .min-300 {
	min-width: 305px;
}

.other-details .margin-left-10 {
	margin-left: 10px;
}

.other-details .margin-top-10 {
	margin-top: 10px;
}

@media only screen and (max-width: 745px) {
	.other-details .margin-left-10 {
		margin-left: 0 !important;
	}
}

.row {
	display: flex;
	width: 100%;
}

.row p {
	margin: 0 !important;
	text-align: left;
}

.row .column-2 {
	flex: 50%;
}

.row .column-1 {
	flex: 50%;
	margin-left: 5px;
}
</style>